import { render, staticRenderFns } from "./FormSesionesTerapia.vue?vue&type=template&id=15d302f2"
import script from "./FormSesionesTerapia.vue?vue&type=script&lang=js"
export * from "./FormSesionesTerapia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports